import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Select,
  Td,
  Input,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Button,
  Checkbox,
  useBreakpointValue,
  List,
  ListItem,
} from "@chakra-ui/react";
import { FaEllipsisV, FaEye, FaTrash, FaPen } from "react-icons/fa";
import axios from "axios";
import styles from "../Tabel.module.css";
import { ACCOUNTS_URL } from "../../../../Globalapi/Globalapi";

const PassBookTable = () => {
  const cmpId = sessionStorage.getItem("cmp_id"); // Default to '1' if not found

  const [passbookData, setPassbookData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [llid, setLlid] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [fdate, setFdate] = useState("2024-04-01");
  const [tdate, setTdate] = useState(new Date().toISOString().split("T")[0]);
  const [companyData, setCompanyData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);
  const [ctotal, setCtotal] = useState([]);
  const [dtotal, setDtotal] = useState([]);
  const [total, settotal] = useState([]);

  const handleSubmit = async () => {
    if (!llid || !fdate || !tdate) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${ACCOUNTS_URL}/reports/load_passbook.php`,
        { fdate, tdate, cmp_id: cmpId, llid, page: 1 }
      );
      console.log("====================================");
      console.log(response);
      console.log("====================================");

      if (response.data.success) {
        setPassbookData(response.data.passbookData);
        setCtotal(response.data.creditTotal || []);
        setDtotal(response.data.debitTotal || []);
        settotal(response.data.totalBalance || []);
      } else {
        console.error("Failed to fetch passbook data:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching passbook data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchTerm.length > 0) {
      const fetchSuggestions = async () => {
        try {
          const response = await axios.post(
            `${ACCOUNTS_URL}/common/load_accounts.php`,
            { cmp_id: cmpId, fectxt: searchTerm }
          );

          console.log("mm", response);

          if (response.data.status === "success") {
            setSuggestions(response.data.data);
          } else {
            setSuggestions([]);
          }
        } catch (error) {
          console.error("Error fetching search suggestions:", error);
        }
      };
      fetchSuggestions();
    } else {
      setSuggestions([]);
    }
  }, [searchTerm, cmpId]);

  const handleSuggestionClick = (suggestionId, suggestionName) => {
    setLlid(suggestionId);
    setSearchTerm(suggestionName);
    setSuggestions([]);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = passbookData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(passbookData.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderRow = (item, index) => {
    const serialNumber = indexOfFirstRow + index + 1;
    const isBold =
      item.sho_name_1 === "Opening Balance" ||
      item.sho_name_1 === "Current Total";

    return (
      <Tr
        key={`${item.vouch_no}-${index}`}
        fontWeight={isBold ? "bold" : "normal"}
      >
        <Td py="12px" px="8px" textAlign="center">
          {/* Conditional rendering of the checkbox */}
          {!isBold && <Checkbox />}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.vouch_date.split(" ")[0]} {/* Only show the date part */}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.vouch_no}
        </Td>

        <Td py="12px" px="20px">
          {item.sho_name_1.split(/(\(.*?\))/g).map((part, idx) => (
            <span
              key={idx}
              style={{ fontStyle: part.startsWith("(") ? "italic" : "normal" }}
            >
              {part}
            </span>
          ))}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.group_head_main}
        </Td>

        <Td py="12px" px="20px" textAlign="right">
          {item.debit}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          {item.credit}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          {item.balance}
        </Td>
      </Tr>
    );
  };

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      setError("User not logged in or user_id not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userId) {
      const fetchCompanyDetails = async () => {
        try {
          const response = await fetch(
            `${ACCOUNTS_URL}/settings/company_details.php`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ user_id: userId }),
            }
          );

          const data = await response.json();

          if (data.status === 200) {
            setCompanyData(data.data);
          } else {
            setError("No company found for this user.");
          }
        } catch (err) {
          setError("Error fetching company details.");
        }
      };

      fetchCompanyDetails();
    }
  }, [userId]); // Run when userId is set

  const printVoucher = () => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    // Define the printable content as HTML
    const printableContent = `
            <html>
                <head>
                    <style>
                        body { font-family: 'Poppins', sans-serif; margin: 20px; }
                        .header, .footer { text-align: center; font-weight: bold; margin-bottom: 10px; }
                .header h2 { margin: 0; font-size: 24px; }
                .header p { margin: 0; font-size: 14px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                        th, td { border: 1px solid #ddd; padding: 8px; }
                        th { background-color: #0073e6; color: white; }
                        tr:nth-child(even) { background-color: #f2f2f2; }
                        tr:hover { background-color: #ddd; }
                        
                        /* Ensure styles are applied for print */
                        @media print {
                            th { background-color: #0073e6 !important; color: white !important; -webkit-print-color-adjust: exact; }
                            tr:nth-child(even) { background-color: #f2f2f2 !important; -webkit-print-color-adjust: exact; }
                            tr:hover { background-color: #ddd !important; -webkit-print-color-adjust: exact; }
                        }
                    </style>
                </head>
                <body>
                <div class="header">
    ${
      companyData?.Company_Name?.startsWith("No") === false
        ? `<h2>${companyData.Company_Name}</h2>`
        : ""
    }

   
    ${
      companyData?.address?.startsWith("No") === false
        ? `<p>${companyData.address}</p>`
        : ""
    }
    ${
      companyData?.Tin?.startsWith("No") === false
        ? `<p>GSTIN/UIN: ${companyData.Tin}</p>`
        : ""
    }
    ${
      companyData?.Email_Id?.startsWith("No") === false
        ? `<p>Email: ${companyData.Email_Id}</p>`
        : ""
    }
</div>
                    <table>
                        <thead>
                            <tr>
                                <th style="text-align: center; padding: 12px;">Date</th>
                                <th style="text-align: center; padding: 12px;">Voucher No.</th>
                                <th style="padding: 12px;">Particulars</th>
                                <th style="text-align: center; padding: 12px;">Type</th>
                                <th style="text-align: right; padding: 12px;">Debit</th>
                                <th style="text-align: right; padding: 12px;">Credit</th>
                                <th style="text-align: right; padding: 12px;">Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${passbookData
                              .map((item, index) => {
                                const isBold =
                                  item.sho_name_1 === "Opening Balance" ||
                                  item.sho_name_1 === "Current Total";
                                return `
                                    <tr style="font-weight: ${
                                      isBold ? "bold" : "normal"
                                    };">
                                        <td style="padding: 12px 20px; text-align: center;">${
                                          item.vouch_date
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: center;">${
                                          item.vouch_no
                                        }</td>
                                        <td style="padding: 12px 20px;">${
                                          item.sho_name_1
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: center;">${
                                          item.group_head_main
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: right;">${
                                          item.debit
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: right;">${
                                          item.credit
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: right;">${
                                          item.balance
                                        }</td>
                                    </tr>
                                `;
                              })
                              .join("")}
                        </tbody>
                    </table>
                </body>
            </html>
        `;

    if (isMobile) {
      // On mobile, open a new window with the printable content
      const printWindow = window.open("", "_blank");
      printWindow.document.open();
      printWindow.document.write(printableContent);
      printWindow.document.close();
      printWindow.print();
    } else {
      // On desktop, use an iframe for printing
      const iframe = document.createElement("iframe");
      document.body.appendChild(iframe);

      // Ensure the iframe is not visible
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";

      // Access the iframe's document and write content
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(printableContent);
      iframeDoc.close();

      // Print from the iframe and remove it afterward
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }
  };

  return (
    <Box mt={3} minH="750px" width="100%" p={1}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        p={3}
        className="sb"
      >
        <Flex
          align="center"
          mb={{ base: 4, md: 0 }}
          justify={{ base: "flex-start", md: "center" }}
        >
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="100px"
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
          <Text ml={2}>Entries</Text>
        </Flex>

        <Stack
          direction={{ base: "column", md: "row" }}
          spacing={4}
          position="relative"
          width="100%"
          justify="flex-end"
        >
          <Input
            type="date"
            placeholder="From Date"
            value={fdate}
            borderColor="#E9EDF4"
            onChange={(e) => setFdate(e.target.value)}
            width={{ base: "100%", md: "auto" }} // Allowing it to take full width on small screens
          />
          <Input
            type="date"
            placeholder="To Date"
            value={tdate}
            borderColor="#E9EDF4"
            onChange={(e) => setTdate(e.target.value)}
            width={{ base: "100%", md: "auto" }} // Allowing it to take full width on small screens
          />
          <Box position="relative" width={{ base: "100%", md: "300px" }}>
            <Input
              type="text"
              placeholder="Search by Name"
              value={searchTerm}
              borderColor="#E9EDF4"
              onChange={(e) => setSearchTerm(e.target.value)}
              width="100%" // Full width within the box
            />
            {suggestions.length > 0 && (
              <Box
                position="absolute"
                width="100%"
                bg="white"
                boxShadow="md"
                borderRadius="md"
                mt={1}
                zIndex={10}
                maxHeight="200px"
                overflowY="auto"
              >
                <List spacing={3}>
                  {suggestions.map((suggestion) => (
                    <ListItem
                      key={suggestion.Ldg_id}
                      onClick={() =>
                        handleSuggestionClick(
                          suggestion.Ldg_id,
                          suggestion.L_name
                        )
                      }
                      style={{ cursor: "pointer" }}
                      _hover={{ backgroundColor: "gray.100" }}
                      px={2}
                      py={1}
                    >
                      {suggestion.L_name} ({suggestion.group_name})
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </Box>
          <Button
            onClick={handleSubmit}
            width={{ base: "100%", md: "auto" }}
            backgroundColor="teal"
            color="white"
          >
            Submit
          </Button>
          <Button onClick={printVoucher}>Print </Button>
        </Stack>
      </Flex>

      <Box
        style={{ overflowX: "auto" }}
        // w={{ base: "367px", md: "100%" }}
        width="100%"
        className={styles.Table}
      >
        {loading ? (
          <Spinner />
        ) : currentData.length > 0 ? (
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
            borderWidth="1px"
          >
            <Thead>
              <Tr>
                <Th
                  textAlign="center"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  <Checkbox />
                </Th>
                <Th
                  textTransform="none"
                  textAlign="center"
                  fontFamily="'Poppins', sans-serif"
                >
                  Date
                </Th>
                <Th
                  textAlign="center"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  Voucher No.
                </Th>
                <Th textTransform="none" fontFamily="'Poppins', sans-serif">
                  Particulars
                </Th>
                <Th
                  textTransform="none"
                  textAlign="center"
                  fontFamily="'Poppins', sans-serif"
                >
                  Type
                </Th>
                <Th
                  textAlign="right"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  Debit
                </Th>
                <Th
                  textAlign="right"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  Credit
                </Th>
                <Th
                  textAlign="right"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  Balance
                </Th>
              </Tr>
            </Thead>
            <Tbody>{currentData.map(renderRow)}</Tbody>
          </Table>
        ) : (
          <Text p={5} textAlign="center">
            No data available.
          </Text>
        )}
      </Box>
      <Table
        sx={{
          "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
        }}
      >
        <Tbody>
          <Tr>
            {/* <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td> */}
            <Td py="12px" px="20px" textAlign="right" colSpan={5}></Td>

            <Td py="12px" px="20px" textAlign="left" fontWeight="bold">
              Current Balance
            </Td>
            {/* <Td py="12px" px="20px" textAlign="right"></Td> */}
            {/* <Td py="12px" px="30px" textAlign="right"></Td> */}
            <Td py="12px" px="30px" textAlign="right" fontWeight="bold">
              {dtotal} Dr
            </Td>

            <Td py="12px" px="20px" textAlign="left" fontWeight="bold">
              {ctotal} Cr
            </Td>
            {/* <Td py="12px" px="10px" textAlign="right"></Td> */}
          </Tr>
          <Tr>
            {/* <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="12px" textAlign="right"></Td>
            <Td py="12px" px="12px" textAlign="right"></Td> */}
            <Td py="12px" px="20px" textAlign="right" colSpan={5}></Td>

            <Td py="12px" px="20px" textAlign="left" fontWeight="bold">
              Closing Balance
            </Td>
            {/* <Td py="12px" px="20px" textAlign="right"></Td> */}
            {/* <Td py="12px" px="30px" textAlign="right"></Td> */}
            <Td py="12px" px="15px" textAlign="right" fontWeight="bold"></Td>
            <Td py="12px" px="6px" textAlign="right" fontWeight="bold">
              {total}{" "}
            </Td>
          </Tr>
        </Tbody>
      </Table>
      <Flex justify="end" className="sb2" borderTopWidth="1px" mt={1} p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages - 1 && (
            <>
              <Text>...</Text>
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default PassBookTable;
